import { BettingOptionsFormat } from '@betgames/bg-tools';
import { GameId } from '@bg-shared/enums/GameId';
import { mapAPIBettingOptionsWithWebSockets } from '@bg-shared/contexts/Games/utils/mapAPIBettingOptionsWithWebSockets';
import { mapToGroupsIds } from '@bg-shared/business/GamesOptions/utils/mapToGroupsIds';
import { IBaccaratProps, IBaccaratGameState } from './interfaces';

export const mapPropsToState = (
    props: IBaccaratProps,
    oddsFormat: BettingOptionsFormat,
): IBaccaratGameState => ({
    oddGroups: mapToGroupsIds(props.bettingOptions.groups),
    presetId: props.bettingOptions.preset,
    data: {
        nextDrawShuffleDeck: false,
        cards: props.draw.run.cards,
        drawCode: props.draw.run.code,
        runId: props.draw.run.id,
        roundId: props.draw.run.roundId,
        runRoundId: props.draw.run.runRoundId,
        gameId: GameId.BACCARAT,
        bettingOptions: mapAPIBettingOptionsWithWebSockets({
            apiOptions: props.bettingOptions,
            webSocketsOptions: props.draw.odds,
            gameId: GameId.BACCARAT,
            format: oddsFormat,
        }),
    },
    groups: props.bettingOptions.groups,
});
